<template>
  <div id="app" :class="{rtl: lang === 'he'}">
    <div id="main-wrapper">
      <!-- header header  -->
      <div class="header">
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
          <!-- Logo -->
          <div class="navbar-header">
            <router-link v-if="user.id!==null" class="navbar-brand" to="/" aria-expanded="false">
              <span>
                <img height="36" src="/static/images/logos/Atid.png" alt="homepage" class="dark-logo"/>
                 <!-- &nbsp;TopEdu -->
              </span>
            </router-link>
            <router-link v-else class="navbar-brand" to="/login" aria-expanded="false">
              <span>
                <img height="36" src="/static/images/logos/Atid.png" alt="homepage" class="dark-logo"/>
                 <!-- &nbsp;TopEdu -->
              </span>
            </router-link>
          </div>
          <!-- End Logo -->
          <div class="collapse navbar-collapse">
            <!-- toggle and nav items -->
            <ul class="navbar-nav ml-auto mt-md-0">
              <!-- This is  -->
              <li class="nav-item">
                <a class="nav-link d-lg-none text-muted" @click="toggleSideBar" href="javascript:void(0)">
                  <i class="mdi mdi-menu"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="rtl" style="width: 100%;">
            <h3 class="mt-2">{{trans('peace')}} {{user.fullName}}</h3>
          </div>
        </nav>
      </div>
      <!-- End header header -->
      <!-- Left Sidebar  -->
      <div class="left-sidebar" :class="{'sidebar-show':sideBar}">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
          <!-- Sidebar navigation-->
          <nav class="sidebar-nav">
            <ul id="sidebar-menu">
              <!-- <li class="nav-devider"></li> -->
              <li class="nav-label" v-if="user.id!==null">{{trans('welcome')}} {{user.fullName}}</li>
              <li class="nav-label" v-else>{{trans('title')}}</li>
              <li @click="toggleSideBar" v-show="user.id!==null">
                <router-link to="/">
                  <i class="fa fa-home"></i>
                  <span class="hide-menu">{{trans('home')}}</span>
                </router-link>
              </li>
              <!-- <li v-show="false" @click="toggleSideBar">
                <router-link class="" to="/profile"><i class="fa fa-user"></i><span
                  class="hide-menu">Profile</span></router-link>
              </li> -->
              <li v-if="user.id===null">
                <a class="has-arrow" href="#login" aria-expanded="false" data-toggle="collapse">
                  <i class="fa fa-key"></i>
                  <span class="hide-menu">{{trans('Auth')}}</span>
                </a>
                <ul id="login" aria-expanded="false" class="collapse">
                  <li @click="toggleSideBar">
                    <router-link to="/login">{{trans('Login')}}</router-link>
                  </li>
                  <!-- <li v-show="false" @click="toggleSideBar">
                    <router-link to="/register">{{trans('register')}}</router-link>
                  </li> -->
                  <!-- <li @click="toggleSideBar">
                    <router-link to="/ForgotPassword">{{trans('forgot')}}</router-link>
                  </li> -->
                </ul>
              </li>
              <!-- <li class="nav-label">{{trans('drivers_management')}}</li> -->
              <!-- <li @click="toggleSideBar">
                <router-link class="" to="/ListDrivers" aria-expanded="false"><i
                  class="fa fa-list"></i><span class="hide-menu">{{trans('drivers_list')}}</span></router-link>
              </li> -->
              <!-- <li @click="toggleSideBar">
                <router-link class="" to="/ManageDriver" aria-expanded="false"><i
                  class="fa fa-plus"></i><span class="hide-menu">{{trans('add_driver')}}</span></router-link>
              </li> -->
              <!-- <li @click="toggleSideBar">
                <router-link class="" to="/ManageDriverDocs" aria-expanded="false"><i
                  class="fa fa-file-pdf-o"></i><span class="hide-menu">{{trans('driver_doc')}}</span></router-link>
              </li> -->
              <!-- <li class="nav-label">{{trans('vehicles_management')}}</li> -->
              <!-- <li @click="toggleSideBar">
                <router-link class="" to="/ListVehicles" aria-expanded="false"><i
                  class="fa fa-list"></i><span class="hide-menu">{{trans('vehicles_list')}}</span></router-link>
              </li> -->
              <!-- <li @click="toggleSideBar">
                <router-link class="" to="/ManageVehicle" aria-expanded="false"><i
                  class="fa fa-plus"></i><span class="hide-menu">{{trans('add_vehicle')}}</span></router-link>
              </li> -->
              <!-- <li class="nav-label">{{trans('about')}}</li>
              <li @click="toggleSideBar">
                <router-link class="" to="/Terms" aria-expanded="false"><i
                  class="fa fa-pencil"></i><span class="hide-menu">{{trans('terms')}}</span></router-link>
              </li> -->
              <!-- <li class="nav-label">{{trans('settings')}}</li>
              <li @click="toggleSideBar">
                <a href="#" @click="switchLang">
                  <span class="flag" :class="{'flag-he': lang === 'he' , 'flag-en' : lang==='en'}"></span>
                </a>
              </li> -->
              <li v-show="user.id!==null">
                <a href="#" @click="logout">
                  <i class="fa fa-sign-out"></i>
                  <span class="hide-menu">{{trans('logout')}}</span>
                </a>
              </li>
            </ul>
          </nav>
          <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
      </div>
      <!-- End Left Sidebar  -->
      <!-- Page wrapper  -->
      <div class="page-wrapper">
        <!-- Bread crumb -->
        <router-view/>
        <!-- footer -->
        <footer class="footer">
          <!-- <img height="30" src="/static/images/logos/Microsoft_Azure_Logo-min.png">&nbsp;<span> © 2019 TopEdu All Right Reserved</span> -->
          <span>כל הזכויות שמורות לחברת טופאדיו © 2020</span>
        </footer>
        <!-- End footer -->
      </div>
      <!-- End Page wrapper  -->
    </div>
  </div>
</template>
<script>
  import { localMixin } from './mixins/localMixin';

  export default {
    name: 'App',
    data() {
      return {
        sideBar: false,
        viewCounter: 0,
        user: {
          id: null,
          lPhone: null,
          lIdentify: null,
          fullName: null,
          token: null,
          logDate: null
        },
        api: {
          host: 'https://app.topedu.co.il/services/api/',
          // host: 'https://localhost:44330/api/',
          getCoursesByLecturer: 'lecturers/getcoursesbylecturer',
          getProjectsByLecturer: 'lecturers/getprojectsbylecturer',
          getMeetingsByCourseLecturer: 'lecturers/getmeetingsbycourselecturer',
          getSessionsByProjectLecturerCategory: 'lecturers/getsessionsbyprojectlecturercategory',
          login: 'lecturers/authenticate',
          getCategoriesByProject: 'lecturers/getcategoriesbyproject',
          submitReport: 'lecturers/submitreport',
          submitNewReport: 'lecturers/submitnewreport',
          getStudentsList: 'lecturers/getstudentslist',
          submitStudentsAttendance: 'lecturers/submitstudentsattendance'
        },
      };
    },
    mixins: [localMixin],
    methods: {
      toggleSideBar() {
        this.sideBar = !this.sideBar;
      },
      logout() {
        this.user = {
          id: null,
          lPhone: null,
          lIdentify: null,
          fullName: null,
          token: null,
          logDate: null
        };
        localStorage.removeItem('user');
        this.$router.push('/login');
        this.sideBar = false;
      },
      loadUser() {
        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.user.token;
        this.$router.push('/');
      },
      destroyUser() {
        localStorage.removeItem('user');
        this.$router.push('/login');
      },
      saveUser() {
        this.user.logDate = Date.now();
        localStorage.setItem('user', JSON.stringify(this.user));
      },
      checkAccess() {
        let user = localStorage.getItem('user');
        if (!user) {
          this.$router.push('/login');
        } else {
          try {
            this.user = JSON.parse(user);
            if (this.user.token && this.user.logDate && (Date.now() - this.user.logDate) < 604800000) {
              this.loadUser();
            } else {
              this.destroyUser();
            }
          } catch (e) {
            this.destroyUser();
          }
        }
      },
    },
    mounted() {
      console.log('TopEdu v1.01');
    },
    beforeMount() {
      this.checkAccess();
    }
  };
</script>
<style>
  @import './assets/css/style.css';

  @media screen and (max-width: 768px) {
    .grecaptcha-badge {
      right: -220px;
    }
  }

  @-webkit-keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }

  @-moz-keyframes rotate {
    0% {
      -moz-transform: rotate(0deg);
    }
    to {
      -moz-transform: rotate(360deg);
    }
  }

  @keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-moz-keyframes heartbit {
    0% {
      -moz-transform: scale(0);
      opacity: 0.0;
    }
    25% {
      -moz-transform: scale(0.1);
      opacity: 0.1;
    }
    50% {
      -moz-transform: scale(0.5);
      opacity: 0.3;
    }
    75% {
      -moz-transform: scale(0.8);
      opacity: 0.5;
    }
    to {
      -moz-transform: scale(1);
      opacity: 0.0;
    }
  }

  @-webkit-keyframes heartbit {
    0% {
      -webkit-transform: scale(0);
      opacity: 0.0;
    }
    25% {
      -webkit-transform: scale(0.1);
      opacity: 0.1;
    }
    50% {
      -webkit-transform: scale(0.5);
      opacity: 0.3;
    }
    75% {
      -webkit-transform: scale(0.8);
      opacity: 0.5;
    }
    to {
      -webkit-transform: scale(1);
      opacity: 0.0;
    }
  }

  @keyframes heartbit {
    0% {
      -webkit-transform: scale(0);
      opacity: 0.0;
    }
    25% {
      -webkit-transform: scale(0.1);
      opacity: 0.1;
    }
    50% {
      -webkit-transform: scale(0.5);
      opacity: 0.3;
    }
    75% {
      -webkit-transform: scale(0.8);
      opacity: 0.5;
    }
    to {
      -webkit-transform: scale(1);
      opacity: 0.0;
    }
  }

  .navbar {
    direction: ltr !important;
  }

  .table-responsive th.VueTables__sortable {
    cursor: pointer;
  }

  .table-responsive th.VueTables__sortable:hover {
    background: #fafafa;
  }

  .glyphicon-chevron-down:before {
    content: "▼";
  }

  .glyphicon-chevron-up:before {
    content: "▲";
  }

  .glyphicon-key:before {
    content: "🔑";
  }

  .loader {
    display: none;
    position: fixed;
    z-index: 99;
    left: 50%;
    top: 50%;
    width: 90px;
    height: auto;
    transform: translate(-50%, -50%);
  }

  .loader.loader-active {
    display: block;
  }

  .h3 {
    word-break: normal;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue